<template>
  <!-- <div>
    <el-alert :closable="false" title="menu 1">
      <router-view />
    </el-alert>
  </div> -->
  <!-- <router-view :key="key" /> -->
  <keep-alive :include="cachedViews">
    <router-view :key="key" />
  </keep-alive>
</template>
<script>
export default {
  // name: "Nested",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>
